import { render, staticRenderFns } from "./OpzioniSpedizioniComandi.vue?vue&type=template&id=db6cf80a"
import script from "./OpzioniSpedizioniComandi.vue?vue&type=script&lang=ts"
export * from "./OpzioniSpedizioniComandi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db6cf80a')) {
      api.createRecord('db6cf80a', component.options)
    } else {
      api.reload('db6cf80a', component.options)
    }
    module.hot.accept("./OpzioniSpedizioniComandi.vue?vue&type=template&id=db6cf80a", function () {
      api.rerender('db6cf80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniSpedizioniComandi.vue"
export default component.exports